document.addEventListener('DOMContentLoaded', function () {
    const variantSelect = document.querySelector('[name="id"]');
    const infoEl = document.getElementById("dynamic-more-info");

    if (!variantSelect || !infoEl || typeof window.variantMoreInfo === "undefined") return;

    // Initial anzeigen
    const initialVariantId = variantSelect.value;
    const initialContent = window.variantMoreInfo[initialVariantId];

    infoEl.innerHTML =
        initialContent && initialContent.trim() !== ""
            ? initialContent.replace(/\n/g, "<br>")
            : window.defaultMoreInfo.replace(/\n/g, "<br>");

    // Bei Wechsel aktualisieren
    variantSelect.addEventListener("change", function () {
        const selectedVariantId = this.value;
        const newContent = window.variantMoreInfo[selectedVariantId];

        infoEl.innerHTML =
            newContent && newContent.trim() !== ""
                ? newContent.replace(/\n/g, "<br>")
                : window.defaultMoreInfo.replace(/\n/g, "<br>");
    });
});
